<div class="row">
	<app-loading-modal [visible]="isLoading" [message]="'Generando reporte'"></app-loading-modal>
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
				<span class="reels-title">
					<i class="fa fa-img"></i> Lista de Unidades
				</span>
				<div *ngIf="isAdmin" class="filter-actions">
				<p-dropdown
					[options]="clientes"
					optionLabel="name"
					optionValue="id"
					[(ngModel)]="selectedClientId"
					(ngModelChange)="onClientChange()"
					styleClass="p-dropdown-sm"
					[filter]="true"
					placeholder="Selecciona un partner"
				></p-dropdown>
				<p-dropdown
					[options]="companias"
					optionLabel="name"
					optionValue="id"
					[(ngModel)]="selectedCompanieId"
					(ngModelChange)="onClientChange()"
					styleClass="p-dropdown-sm"
					[filter]="true"
					placeholder="Selecciona una compañia"
				></p-dropdown>

				<button
					*ngIf="selectedClientId || selectedCompanieId"
					type="button"
					class="btn btn-sm btn-outline-secondary btn-clear"
					(click)="clearFilters()"
					title="Quitar filtro"
				>
					<i class="fa fa-times"></i>
				</button>
				</div>
				<span class="btn-add-container">
					<button class="btn btn-primary btn-add action-btn" (click)="add()">
						<i class="fa fa-plus-square"></i>
						Agregar Cliente
					</button>
				</span>
			</div>
			<div class="card-body">
				<app-datatable [options]="dtConfig"></app-datatable>
			</div>
		</div>
	</div>
</div>
